<style scoped>
.h-btn {
    min-width: 200px;
}

.no-href-dec {
    text-decoration: none;
    cursor: pointer;
}
.branch-select{
    min-width:200px
}
</style>
<template>
    <!-- Content -->
    <div class="content-wrapper">
        <div class="row mb-3">
            <div class="col-md-12">
                <div class="row">
                    <div class="col-8 col-md-10 mb-4 mb-xl-0">
                        <h3 class="font-weight-bold">Customers</h3>
                    </div>
                    <div class="col-4 col-md-2">
                      <button v-if="!contact_form" @click="showSMSForm" class="btn btn-primary text-white simple-btn">Send SMS</button>
                      <button v-if="contact_form" @click="showSMSForm" class="btn btn-danger text-white simple-btn">Close SMS</button>  
                    </div>
                </div>
            </div>
        </div>

           <div v-if="user.role > 1">   
    <div class="mt-3"></div>
    <h5>Customers Summary</h5>
    <div class="row">
        <div class="col-6 col-sm-6 col-md-3 mb-4 stretch-card transparent">
            <div class="card card-glau">
                <div class="card-body d-flex justify-content-between">
                    <p>To Day</p>
                    <p class="fs-25"><PriceFormat :Price="dataz.day1"/></p>
                   
                </div>
            </div>
        </div>
        <div class="col-6 col-sm-6 col-md-3 mb-4 stretch-card transparent">
            <div class="card card-glau">
                <div class="card-body d-flex justify-content-between">
                     <p>Last 7Day</p>
                    <p class="fs-25"><PriceFormat :Price="dataz.day7"/></p>
                  
                </div>
            </div>
        </div>
        <div class="col-6 col-sm-6 col-md-3 mb-4 stretch-card transparent">
            <div class="card card-glau">
                <div class="card-body d-flex justify-content-between">
                     <p>Last 30Day</p>
                    <p class="fs-25"><PriceFormat :Price="dataz.day30"/></p>
                  
                </div>
            </div>
        </div>
        <div class="col-6 col-sm-6 col-md-3 mb-4 stretch-card transparent">
           <div class="card card-glau">
                <div class="card-body d-flex justify-content-between">
                    <p>Total Cust..</p>
                    <p class="fs-25"><PriceFormat :Price="dataz.total"/></p>
                   
                </div>
            </div>
        </div>
    </div>
    </div>

        <div class="row">
            <div class="col-12">

                <div class="row mb-3">
                                         <div class="col-sm-12 col-md-3 col-12 stretch-card col-grid">
                                             <div class="" style="height: 40px !important;">
                                            <div class="card-body d-flex justify-content-between">
                    <h5>On Table Customers : </h5>
                    <p class="fs-25"><PriceFormat :Price="customers.length"/></p>
                   
                </div>
                </div>
                                         </div>
                                          <div class="col-sm-4 col-md-6 col-6 stretch-card col-grid"></div>
                   
                    <div class="col-sm-4 col-md-2 col-6 stretch-card col-grid">
                        <input type="text" placeholder="phone or name" v-model="search_field" class="date_input form-control"/>             
                    </div>
                    <div class="col-sm-4 col-md-1 col-6 stretch-card col-grid">
                         <button id="filter_btn" @click="searchCustomers" class="btn btn-primary simple-btn">Search</button>
                    </div>
 </div>
                <div class="row">
                    <div class="col-sm-4 col-md-2 col-6 stretch-card col-grid">
 <input class="date_input form-control" v-model="this.fdate" type="date">
                    </div>
                    <div class="col-sm-4 col-md-2 col-6 stretch-card col-grid">
                         <input class="date_input form-control" type="date" v-model="this.tdate">
                    </div>
                    <div class="col-sm-6 col-md-1 col-6 stretch-card col-grid">
                        <select class="form-select form-control w-100" v-model="filter_type"
                    style="width: auto">
                    <option value="0">Send Parcel</option>
                    <option value="1">Joined At</option>
                </select>
                    </div>

                    <div class="col-sm-12 col-md-3 col-12 stretch-card col-grid">
                        <div class="d-flex w-100">
                                            <input type="text" v-model="this.filter_branch"
                                                style="width: 100px !important;" class="form-control"
                                                placeholder="Filter">
                                            <select v-model="branch_from" class="form-select form-control">
                                                <option v-for="branch in branches" :key="branch.id" :value="branch.id">
                                                    {{ branch.name }}
                                                </option>
                                            </select>

                                        </div></div>
               
                 <div class="col-sm-12 col-md-3 col-12 stretch-card col-grid">
                        <div class="d-flex w-100">
                                            <input type="text" v-model="this.to_branch"
                                                style="width: 100px !important;" class="form-control"
                                                placeholder="Filter">
                                            <select v-model="branch_to" class="form-select form-control">
                                                <option v-for="branch in to_branches" :key="branch.id" :value="branch.id">
                                                    {{ branch.name }}
                                                </option>
                                            </select>

                                        </div></div>
                    
                    <div class="col-sm-4 col-md-1 col-6 stretch-card col-grid">
                         <button id="filter_btn" @click="filterCustomers" class="btn btn-success simple-btn">Filter</button>
                    </div>

                    
                </div>

                <div v-if="contact_form">
                    <div class="card mt-3">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-7 col-sm-12">
                                    <div class="form-group">
                                        <label for="">Phone numbers (comma separated)</label>
                                       <textarea
    class="form-control"
    rows="5"
    v-model="phone_list"
    @input="phoneListChanged"
></textarea>
                                    </div>
                                    <div class="mt-2 text-danger">
    Total phone numbers: {{ totalPhones }}
</div>
                                </div>
                                <div class="col-md-5 col-sm-12">
                                    <div class="form-group">
                                        <label for="">Message</label>
                                        <textarea class="form-control" v-model="this.message"></textarea>
                                    </div>
                                   
                                    <div class="d-flex justify-content-between">
                                        <button class="btn btn-primary" @click="sendSms()">Send SMS</button>
                                        <button class="btn btn-danger text-white" @click="clearPhoneList">Clear Chat</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                 <div v-if="loading" class="mt-1">
                                                <div class="text-center">
                                                    <div class="spinner-grow text-success" role="status"></div>
                                                    <div class="spinner-grow text-danger" role="status"></div>
                                                    <div class="spinner-grow text-warning" role="status"></div>
                                                </div>
                                            </div>

                <div class="table-responsive">
                    
                    <table class="table table-striped mt-3">
                        <thead>
                          <tr>
                            <th>No</th>
                            <th>Fullname</th>
                            <th>
    <input
        type="checkbox"
        v-model="checkAll"
        @change="masterCheckBox"
        class="phone_num"
        id="check_box_all"
    >
    <span class="m-1"></span>

    <label for="check_box_all">
        Phone No's
    </label>
</th>
                            <th>Sents</th>
                            <th>Total Paid</th>
                            <!--th>Created by</th-->
                            <th>Joined At</th>
                            <th>Parcels</th>

                        </tr>
                        </thead>
                        <tbody id="incoming-list">

                            <tr v-for="(customer, index) in paginatedCustomers" :key="customer.id" :id="'customer_'+message.id">
                                
                              <td>{{ (currentPage - 1) * perPage + index + 1 }}</td>
                            <td>{{customer.fulname}}</td>
                            <td class="phone-no">
    <input
        type="checkbox"
        class="child_check"
        :id="'check_box_' + customer.phone_no"
        :value="customer.phone_no"
        v-model="selectedPhones"
        @change="checkBoxs(customer.phone_no)"
    >

    <span class="m-1"></span>

    <label
        class="text-success"
        :for="'check_box_' + customer.phone_no"
    >
        <PhoneFormat :Phone="customer.phone_no"/>
    </label>
</td>
                            <td><span class="badge badge-primary"><PriceFormat :Price="customer.sents"/></span></td>
                            <td><span class="badge badge-success"><PriceFormat :Price="customer.paids"/></span></td>
                            <!--td>{{customer.created_by}}</td-->
                            <td><DateFormat :Date_="customer.created_at"/></td>
                            <td>
                                <a :href="'/customer/'+customer.phone_no" type="button" class="btn btn-primary">
                                    view
                                </a>

                            </td>
                            </tr>
                          
                        </tbody>
                    </table>
                </div>
                           <div v-if="this.customers.length > 0" class="pagination-wrapper">

  <button 
    @click="currentPage--"
    :disabled="currentPage === 1">
    Prev
  </button>

  <button
    v-for="page in totalPages"
    :key="page"
    @click="currentPage = page"
    :class="{ active: currentPage === page }">
    {{ page }}
  </button>

  <button
    @click="currentPage++"
    :disabled="currentPage === totalPages">
    Next
  </button>

</div>
            </div>
        </div>
    </div>


</template>
<script>
import axios from "axios";

import PriceFormat from "@/components/PriceFormat.vue";
import PhoneFormat from "@/components/PhoneFormat.vue";
import DateFormat from "@/components/DateFormat.vue";


export default {
    components: {
        PriceFormat,
        PhoneFormat,
        DateFormat,

    },
    data() {
        return {
            loading: false,
            loading_sms_details:false,
            contact_form:false,
            errors: "",
            search_field:"",
            to_branches:[],
            branches: [],
            og_branches: [],
            filter_branch: "",
            to_branch:"",
            branch_from:0,
             branch_to:0,
             filter_type:0,
            phone_list:"",
            message:"",
            selectedPhones: [],
            totalPhones: 0,
        checkAll: false,
            fdate:"",
            tdate:"",
            customers:[],
            og_customers:[],
           dataz:{},
            parcel: {},
            currentPage: 1,
            perPage: 30,
            user: this.$attrs.user
        };
    },
    methods: {

           masterCheckBox() {
            this.contact_form = true
        if (this.checkAll) {

            // Select all customer phone numbers
            this.selectedPhones = this.customers
                .map(customer => customer.phone_no)
                .filter(phone => phone);

        } else {

            // Unselect everything
            this.selectedPhones = [];
        }

        // Convert array to comma-separated string
        this.phone_list = this.selectedPhones.join(",");

          this.phoneListChanged()
    },

    phoneListChanged() {
        
        const phones = this.phone_list
            .split(",")
            .map(phone => phone.trim())
            .filter(phone => phone !== "");

        this.totalPhones = phones.length;
    },

    checkBoxs(phone_no) {

        this.contact_form = true

        // v-model has already added/removed the phone number
        // from selectedPhones at this point.

        this.phone_list = this.selectedPhones.join(",");

        // Update master checkbox
        this.checkAll =
            this.selectedPhones.length === this.customers.length;

            this.phoneListChanged()
    },

         async getAllBranch() {

            var response = await axios
                .get(this.$store.state.api_url + "/branch/all-branches")
                .catch((errors) => {
                    var message = "Network or Server Errors";
                    this.$toast.error(message, { duration: 5000, dismissible: true });
                });

            //console.log(response.data)
            if (response.data.success) {

                this.branches = [ { id: 0, name: "All Branches" },...response.data.branches];
                this.to_branches = [ { id: 0, name: "All Branches" },...response.data.branches];
                this.og_branches = [ { id: 0, name: "All Branches" },...response.data.branches];

            } else {
                var message = response.data.message;
                this.$toast.error(message, { duration: 5000, dismissible: true });
            }
        },

        async filterCustomers(){

             this.loading = true

          var filter_type = this.filter_type
          var sdate = this.fdate
          var edate = this.tdate
          var branch_from = this.branch_from
           var branch_to = this.branch_to


          var response = await axios
              .post(this.$store.state.api_url + "/filter-customers", {sdate, edate, filter_type, branch_to, branch_from})
              .catch((errors) => {
                    this.loading = false
                  var message = "Network or Server Errors";
                  this.$toast.error(message, { duration: 5000, dismissible: true });
              });

          //console.log(response.data)
          if (response.data.success) {

               this.loading = false

                this.customers = response.data.customers;
                this.og_customers = response.data.customers
             
          } else {
                this.loading = false
              var message = response.data.message;
              this.$toast.error(message, { duration: 5000, dismissible: true });
          }

        },

             async searchCustomers(){

          var search_field = this.search_field

          if(search_field == "" || search_field == null || search_field == undefined){
            alert("Type search key world")
            return true
          }

           this.loading = true
        
          var response = await axios
              .post(this.$store.state.api_url + "/search-customers", {search_field})
              .catch((errors) => {
                    this.loading = false
                  var message = "Network or Server Errors";
                  this.$toast.error(message, { duration: 5000, dismissible: true });
              });

          //console.log(response.data)
          if (response.data.success) {

               this.loading = false

                this.customers = response.data.customers;
                this.og_customers = response.data.customers
             
          } else {
                this.loading = false
              var message = response.data.message;
              this.$toast.error(message, { duration: 5000, dismissible: true });
          }

        },

        showSMSForm(){
            this.contact_form = !this.contact_form
        },

        async getCustomers() {

            this.loading = true

            var response = await axios
                .get(this.$store.state.api_url + "/get-customers")
                .catch((errors) => {
                    this.loading = false
                    var message = "Network or Server Errors";
                    this.$toast.error(message, { duration: 5000, dismissible: true });
                });

            //console.log(response.data)
            if (response.data.success) {
                  this.loading = false
                this.customers = response.data.customers;
                 this.dataz = response.data.dataz;
               
                this.og_customers = response.data.customers

               /// console.log(this.messages)

            } else {
                  this.loading = false
                var message = response.data.message;
                this.$toast.error(message, { duration: 5000, dismissible: true });
            }
        },
         nextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++
    }
  },

  prevPage() {
    if (this.currentPage > 1) {
      this.currentPage--
    }
  },

 addPhoneList(phone) {

    this.contact_form = true
        // Convert string to array and remove empty values
        let phones = this.phone_list
            ? this.phone_list.split(",").map(p => p.trim()).filter(Boolean)
            : [];

        // Check if phone already exists
        const index = phones.indexOf(phone);

        if (index !== -1) {
            if (confirm(`${phone} already exists.\n\nDo you want to remove it?`)) {
                phones.splice(index, 1);
            } else {
                return;
            }
        } else {
            phones.push(phone);
        }

        // Convert back to comma-separated string
        this.phone_list = phones.join(",");
    },
    clearPhoneList(){
        this.phone_list = ""
    },
  async sendSms (){

    this.loading = true

          var phone_list = this.phone_list
          var message = this.message

          var response = await axios
              .post(this.$store.state.api_url + "/send-multi-sms", {phone_list, message})
              .catch((errors) => {
                    this.loading = false
                  var message_ = "Network or Server Errors";
                  this.$toast.error(message_, { duration: 5000, dismissible: true });
              });

          //console.log(response.data)
          if (response.data.success) {
               this.loading = false
             
              var message_ = response.data.message;
              this.$toast.success(message_, { duration: 5000, dismissible: true });

              this.phone_list = ""
              this.message = ""

          } else {
            
                this.loading = false
              var message_ = response.data.message;
              this.$toast.error(message_, { duration: 5000, dismissible: true });
          }
    },
    truncate(text, length = 30) {

        if (!text) return "";

        return text.length > length
            ? text.substring(0, length) + ".."
            : text;

    }

    },
      computed: {

  paginatedCustomers() {
    const start = (this.currentPage - 1) * this.perPage
    const end = start + this.perPage

    return this.customers.slice(start, end)
  },

  totalPages() {
    return Math.ceil(this.customers.length / this.perPage)
  },
  

},
     watch: {

        filter_branch(value) {

            let term = value.toLowerCase().trim()

            if (!term) {
                this.branches = this.og_branches
                return
            }

            this.branches = this.og_branches.filter(branch => {

                return (
                    (branch.name && branch.name.toLowerCase().includes(term)) || 
                    (branch.region && branch.region.toLowerCase().includes(term))
                )

            })

        },
        to_branch(value) {

            let term = value.toLowerCase().trim()

            if (!term) {
                this.to_branches = this.og_branches
                return
            }

            this.to_branches = this.og_branches.filter(branch => {

                return (
                    (branch.name && branch.name.toLowerCase().includes(term)) || 
                    (branch.region && branch.region.toLowerCase().includes(term))
                )

            })

        }
    },
    created() {
        this.$store.state.page_name = "Dashbord"
        this.getCustomers()
        this.getAllBranch()
    },
    mounted() {
        //$('#dashbord').attr('class', 'nav-item active');
    }
};
</script>
